var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.3,
    cy: 34.127,
    r: 34,
    fill: "#FFB342"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3 20.127C28.7792 20.127 24.3 24.5543 24.3 30.0073C24.3 36.2816 30.9667 46.2246 33.4146 49.6589C33.5162 49.8039 33.6494 49.9219 33.8033 50.0032C33.9572 50.0846 34.1274 50.127 34.3 50.127C34.4727 50.127 34.6429 50.0846 34.7968 50.0032C34.9507 49.9219 35.0839 49.8039 35.1855 49.6589C37.6334 46.2261 44.3 36.2867 44.3 30.0073C44.3 24.5543 39.8209 20.127 34.3 20.127Z",
    stroke: "#1C2752",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3 35.127C36.5092 35.127 38.3 33.3361 38.3 31.127C38.3 28.9178 36.5092 27.127 34.3 27.127C32.0909 27.127 30.3 28.9178 30.3 31.127C30.3 33.3361 32.0909 35.127 34.3 35.127Z",
    stroke: "#1C2752",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/locationicon.ccace70c9261be4bd66e49594c04e926.svg";
export { ForwardRef as ReactComponent };